import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './SelectedDeviceCard.Styles';

const renderDeviceIcon = (image, style) => (
  <Icon size={33} style={[styles.deviceIcon, style]} name={image} />
);
const SelectedDeviceCard = ({ selectedDevice = {} }) => {
  const theme = useTheme();
  const { name, brand, image, color, capacity } = selectedDevice || {};
  return (
    <View>
      <VFText
        style={styles.myDevice(theme)}
        i18nKey={'device_upgrade_summary_step_my_new_device'}
      />

      <View style={styles.card(theme)}>
        <View style={styles.deviceInfo(theme)}>
          {renderDeviceIcon(image)}
          <View>
            <VFText style={styles.deviceInfoTitle(theme)} i18nKey={brand} />
            <VFText style={styles.deviceInfoSubTitle} i18nKey={name} />
          </View>
        </View>

        <View style={styles.deviceCapacityContainer}>
          {renderDeviceIcon(image, styles.hiddenDeviceIcon)}
          <VFText
            type={'primary'}
            style={styles.deviceCapacityText}
            i18nKey={`${capacity?.toUpperCase()} `}
          />
          <VFText
            style={styles.deviceCapacityText}
            type={'primary'}
            i18nKey={'device_upgrade_summary_step_device_capacity'}
          />
          <VFText style={styles.deviceCapacityText} type={'primary'} i18nKey={' - '} />
          <VFText type={'primary'} style={styles.deviceCapacityText} i18nKey={color} />
        </View>
      </View>
    </View>
  );
};
SelectedDeviceCard.propTypes = {
  selectedDevice: PropTypes.object,
};
export default SelectedDeviceCard;
